'use client';

import React, { useState } from 'react';
import { Box, Button, Collapsible } from '@skin-seoul/design-system';
export interface ReadMoreContentProps {
  children: React.ReactNode;
  noOfLines?: number;
  expandButtonText?: string;
  collapseButtonText?: string;
  ariaLabel?: string;
  buttonVariant?: 'ghost' | 'outline';
  gap?: {
    base: string;
    tablet: string;
  };
  onExpandedChange?: (isExpanded: boolean) => void;
}
const ReadMoreContent = ({
  children,
  noOfLines = 3,
  expandButtonText = 'more',
  collapseButtonText = 'less',
  ariaLabel = 'text',
  buttonVariant = 'ghost',
  gap = {
    base: '1',
    tablet: '0'
  },
  onExpandedChange
}: ReadMoreContentProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return <Collapsible.Root open={isExpanded} onOpenChange={details => {
    setIsExpanded(details.open);
    onExpandedChange?.(details.open);
  }} gap={gap} display="flex" flexDirection="column" data-sentry-element="Collapsible.Root" data-sentry-component="ReadMoreContent" data-sentry-source-file="ReadMoreContent.tsx">
      {!isExpanded && <Box lineClamp={noOfLines}>{children}</Box>}

      <Collapsible.Content data-sentry-element="Collapsible.Content" data-sentry-source-file="ReadMoreContent.tsx">
        <Box data-sentry-element="Box" data-sentry-source-file="ReadMoreContent.tsx">{children}</Box>
      </Collapsible.Content>

      <Collapsible.Trigger asChild data-sentry-element="Collapsible.Trigger" data-sentry-source-file="ReadMoreContent.tsx">
        <Button variant={buttonVariant} size="sm" fontWeight="medium" aria-expanded={isExpanded} aria-label={isExpanded ? `Show less ${ariaLabel}` : `Show more ${ariaLabel}`} {...buttonVariant === 'ghost' && {
        color: 'neutral.400',
        alignSelf: 'start',
        padding: 0,
        height: 'auto',
        _hover: {
          color: 'primary.700'
        }
      }} {...buttonVariant === 'outline' && {
        borderColor: 'neutral.700',
        color: 'neutral.700',
        borderRadius: '8px',
        alignSelf: {
          base: 'stretch',
          tablet: 'center'
        },
        paddingX: 8,
        paddingY: 4,
        width: {
          base: '100%',
          tablet: '328px'
        },
        height: '48px',
        _hover: {
          borderColor: 'neutral.200',
          backgroundColor: 'neutral.50'
        }
      }} data-sentry-element="Button" data-sentry-source-file="ReadMoreContent.tsx">
          {isExpanded ? collapseButtonText : expandButtonText}
        </Button>
      </Collapsible.Trigger>
    </Collapsible.Root>;
};
export default ReadMoreContent;